import { arrayMap } from "../../utils/array.utils";

export default function TableHeader({ thead = [] }) {
  return (
    <thead>
      <tr>
        {arrayMap(thead, (item) => (
          <th key={item} scope="col" style={{ width: 100 / thead.length }}>
            {item}
          </th>
        ))}
      </tr>
    </thead>
  );
}
